import _createClass from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import t, { PureComponent as e } from "react";
function i(t, e, i, n) {
  return new (i || (i = Promise))(function (s, r) {
    function l(t) {
      try {
        o(n.next(t));
      } catch (t) {
        r(t);
      }
    }
    function a(t) {
      try {
        o(n.throw(t));
      } catch (t) {
        r(t);
      }
    }
    function o(t) {
      var e;
      t.done ? s(t.value) : (e = t.value, e instanceof i ? e : new i(function (t) {
        t(e);
      })).then(l, a);
    }
    o((n = n.apply(t, e || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
var n = function n(t, e, i, _n) {
    t.style.transition = "".concat(e, " ").concat(i, "ms ").concat(_n);
  },
  s = function s(t, e, i) {
    return Math.min(Math.max(t, e), i);
  };
var r = function r(t, e) {
  var _this = this;
  _classCallCheck(this, r);
  this.glareAngle = 0, this.glareOpacity = 0, this.calculateGlareSize = function (t) {
    var e = t.width,
      i = t.height,
      n = Math.sqrt(Math.pow(e, 2) + Math.pow(i, 2));
    return {
      width: n,
      height: n
    };
  }, this.setSize = function (t) {
    var e = _this.calculateGlareSize(t);
    _this.glareEl.style.width = "".concat(e.width, "px"), _this.glareEl.style.height = "".concat(e.height, "px");
  }, this.update = function (t, e, i, n) {
    _this.updateAngle(t, e.glareReverse), _this.updateOpacity(t, e, i, n);
  }, this.updateAngle = function (t, e) {
    var i = t.xPercentage,
      n = t.yPercentage,
      s = 180 / Math.PI,
      r = i ? Math.atan2(n, -i) * s : 0;
    _this.glareAngle = r - (e ? 180 : 0);
  }, this.updateOpacity = function (t, e, i, n) {
    var r = t.xPercentage,
      l = t.yPercentage,
      a = e.glarePosition,
      o = e.glareReverse,
      h = e.glareMaxOpacity,
      p = i ? -1 : 1,
      c = n ? -1 : 1,
      g = o ? -1 : 1;
    var d = 0;
    switch (a) {
      case "top":
        d = -r * p * g;
        break;
      case "right":
        d = l * c * g;
        break;
      case "bottom":
      case void 0:
        d = r * p * g;
        break;
      case "left":
        d = -l * c * g;
        break;
      case "all":
        d = Math.hypot(r, l);
    }
    var u = s(d, 0, 100);
    _this.glareOpacity = u * h / 100;
  }, this.render = function (t) {
    var e = t.glareColor;
    _this.glareEl.style.transform = "rotate(".concat(_this.glareAngle, "deg) translate(-50%, -50%)"), _this.glareEl.style.opacity = _this.glareOpacity.toString(), _this.glareEl.style.background = "linear-gradient(0deg, rgba(255,255,255,0) 0%, ".concat(e, " 100%)");
  }, this.glareWrapperEl = document.createElement("div"), this.glareEl = document.createElement("div"), this.glareWrapperEl.appendChild(this.glareEl), this.glareWrapperEl.className = "glare-wrapper", this.glareEl.className = "glare";
  var i = {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      borderRadius: e,
      WebkitMaskImage: "-webkit-radial-gradient(white, black)",
      pointerEvents: "none"
    },
    n = this.calculateGlareSize(t),
    _r = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transformOrigin: "0% 0%",
      pointerEvents: "none",
      width: "".concat(n.width, "px"),
      height: "".concat(n.height, "px")
    };
  Object.assign(this.glareWrapperEl.style, i), Object.assign(this.glareEl.style, _r);
};
var l = function l() {
  var _this2 = this;
  _classCallCheck(this, l);
  this.glareAngle = 0, this.glareOpacity = 0, this.tiltAngleX = 0, this.tiltAngleY = 0, this.tiltAngleXPercentage = 0, this.tiltAngleYPercentage = 0, this.update = function (t, e) {
    _this2.updateTilt(t, e), _this2.updateTiltManualInput(t, e), _this2.updateTiltReverse(e), _this2.updateTiltLimits(e);
  }, this.updateTilt = function (t, e) {
    var i = t.xPercentage,
      n = t.yPercentage,
      s = e.tiltMaxAngleX,
      r = e.tiltMaxAngleY;
    _this2.tiltAngleX = i * s / 100, _this2.tiltAngleY = n * r / 100 * -1;
  }, this.updateTiltManualInput = function (t, e) {
    var i = e.tiltAngleXManual,
      n = e.tiltAngleYManual,
      s = e.tiltMaxAngleX,
      r = e.tiltMaxAngleY;
    (null !== i || null !== n) && (_this2.tiltAngleX = null !== i ? i : 0, _this2.tiltAngleY = null !== n ? n : 0, t.xPercentage = 100 * _this2.tiltAngleX / s, t.yPercentage = 100 * _this2.tiltAngleY / r);
  }, this.updateTiltReverse = function (t) {
    var e = t.tiltReverse ? -1 : 1;
    _this2.tiltAngleX = e * _this2.tiltAngleX, _this2.tiltAngleY = e * _this2.tiltAngleY;
  }, this.updateTiltLimits = function (t) {
    var e = t.tiltAxis;
    _this2.tiltAngleX = s(_this2.tiltAngleX, -90, 90), _this2.tiltAngleY = s(_this2.tiltAngleY, -90, 90);
    e && (_this2.tiltAngleX = "x" === e ? _this2.tiltAngleX : 0, _this2.tiltAngleY = "y" === e ? _this2.tiltAngleY : 0);
  }, this.updateTiltAnglesPercentage = function (t) {
    var e = t.tiltMaxAngleX,
      i = t.tiltMaxAngleY;
    _this2.tiltAngleXPercentage = _this2.tiltAngleX / e * 100, _this2.tiltAngleYPercentage = _this2.tiltAngleY / i * 100;
  }, this.render = function (t) {
    t.style.transform += "rotateX(".concat(_this2.tiltAngleX, "deg) rotateY(").concat(_this2.tiltAngleY, "deg) ");
  };
};
var a = Object.assign(Object.assign({
  scale: 1,
  perspective: 1e3,
  flipVertically: !1,
  flipHorizontally: !1,
  reset: !0,
  transitionEasing: "cubic-bezier(.03,.98,.52,.99)",
  transitionSpeed: 400,
  trackOnWindow: !1,
  gyroscope: !1
}, {
  tiltEnable: !0,
  tiltReverse: !1,
  tiltAngleXInitial: 0,
  tiltAngleYInitial: 0,
  tiltMaxAngleX: 20,
  tiltMaxAngleY: 20,
  tiltAxis: void 0,
  tiltAngleXManual: null,
  tiltAngleYManual: null
}), {
  glareEnable: !1,
  glareMaxOpacity: .7,
  glareColor: "#ffffff",
  glarePosition: "bottom",
  glareReverse: !1,
  glareBorderRadius: "0"
});
var o = /*#__PURE__*/function (_e) {
  _inherits(o, _e);
  function o() {
    var _this3;
    _classCallCheck(this, o);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments)), _this3.wrapperEl = {
      node: null,
      size: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      clientPosition: {
        x: null,
        y: null,
        xPercentage: 0,
        yPercentage: 0
      },
      updateAnimationId: null,
      scale: 1
    }, _this3.tilt = null, _this3.glare = null, _this3.addDeviceOrientationEventListener = function () {
      return i(_assertThisInitialized(_assertThisInitialized(_this3)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var t;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (window.DeviceOrientationEvent) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              t = DeviceOrientationEvent.requestPermission;
              if (!("function" == typeof t)) {
                _context.next = 12;
                break;
              }
              _context.next = 6;
              return t();
            case 6:
              _context.t0 = _context.sent;
              _context.t1 = "granted" === _context.t0;
              if (!_context.t1) {
                _context.next = 10;
                break;
              }
              window.addEventListener("deviceorientation", this.onMove);
            case 10:
              _context.next = 13;
              break;
            case 12:
              window.addEventListener("deviceorientation", this.onMove);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }, _this3.setSize = function () {
      _this3.setWrapperElSize(), _this3.glare && _this3.glare.setSize(_this3.wrapperEl.size);
    }, _this3.mainLoop = function (t) {
      null !== _this3.wrapperEl.updateAnimationId && cancelAnimationFrame(_this3.wrapperEl.updateAnimationId), _this3.processInput(t), _this3.update(t.type), _this3.wrapperEl.updateAnimationId = requestAnimationFrame(_this3.renderFrame);
    }, _this3.onEnter = function (t) {
      var e = _this3.props.onEnter;
      _this3.setSize(), _this3.wrapperEl.node.style.willChange = "transform", _this3.setTransitions(), e && e(t.type);
    }, _this3.onMove = function (t) {
      _this3.mainLoop(t), _this3.emitOnMove(t);
    }, _this3.onLeave = function (t) {
      var e = _this3.props.onLeave;
      if (_this3.setTransitions(), e && e(t.type), _this3.props.reset) {
        var _t = new CustomEvent("autoreset");
        _this3.onMove(_t);
      }
    }, _this3.processInput = function (t) {
      var e = _this3.props.scale;
      switch (t.type) {
        case "mousemove":
          _this3.wrapperEl.clientPosition.x = t.pageX, _this3.wrapperEl.clientPosition.y = t.pageY, _this3.wrapperEl.scale = e;
          break;
        case "touchmove":
          _this3.wrapperEl.clientPosition.x = t.touches[0].pageX, _this3.wrapperEl.clientPosition.y = t.touches[0].pageY, _this3.wrapperEl.scale = e;
          break;
        case "deviceorientation":
          _this3.processInputDeviceOrientation(t), _this3.wrapperEl.scale = e;
          break;
        case "autoreset":
          var _this3$props = _this3.props,
            _i = _this3$props.tiltAngleXInitial,
            _n2 = _this3$props.tiltAngleYInitial,
            _r2 = _this3$props.tiltMaxAngleX,
            _l = _this3$props.tiltMaxAngleY,
            _a = _n2 / _l * 100;
          _this3.wrapperEl.clientPosition.xPercentage = s(_i / _r2 * 100, -100, 100), _this3.wrapperEl.clientPosition.yPercentage = s(_a, -100, 100), _this3.wrapperEl.scale = 1;
      }
    }, _this3.processInputDeviceOrientation = function (t) {
      if (!t.gamma || !t.beta || !_this3.props.gyroscope) return;
      var _this3$props2 = _this3.props,
        e = _this3$props2.tiltMaxAngleX,
        i = _this3$props2.tiltMaxAngleY,
        n = t.gamma;
      _this3.wrapperEl.clientPosition.xPercentage = t.beta / e * 100, _this3.wrapperEl.clientPosition.yPercentage = n / i * 100, _this3.wrapperEl.clientPosition.xPercentage = s(_this3.wrapperEl.clientPosition.xPercentage, -100, 100), _this3.wrapperEl.clientPosition.yPercentage = s(_this3.wrapperEl.clientPosition.yPercentage, -100, 100);
    }, _this3.update = function (t) {
      var _this3$props3 = _this3.props,
        e = _this3$props3.tiltEnable,
        i = _this3$props3.flipVertically,
        n = _this3$props3.flipHorizontally;
      "autoreset" !== t && "deviceorientation" !== t && "propChange" !== t && _this3.updateClientInput(), e && _this3.tilt.update(_this3.wrapperEl.clientPosition, _this3.props), _this3.updateFlip(), _this3.tilt.updateTiltAnglesPercentage(_this3.props), _this3.glare && _this3.glare.update(_this3.wrapperEl.clientPosition, _this3.props, i, n);
    }, _this3.updateClientInput = function () {
      var t = _this3.props.trackOnWindow;
      var e, i;
      if (t) {
        var _this3$wrapperEl$clie = _this3.wrapperEl.clientPosition,
          _t2 = _this3$wrapperEl$clie.x,
          _n3 = _this3$wrapperEl$clie.y;
        e = _n3 / window.innerHeight * 200 - 100, i = _t2 / window.innerWidth * 200 - 100;
      } else {
        var _this3$wrapperEl = _this3.wrapperEl,
          _this3$wrapperEl$size = _this3$wrapperEl.size,
          _t3 = _this3$wrapperEl$size.width,
          _n4 = _this3$wrapperEl$size.height,
          _s = _this3$wrapperEl$size.left,
          _r3 = _this3$wrapperEl$size.top,
          _this3$wrapperEl$clie2 = _this3$wrapperEl.clientPosition,
          _l2 = _this3$wrapperEl$clie2.x,
          _a2 = _this3$wrapperEl$clie2.y;
        e = (_a2 - _r3) / _n4 * 200 - 100, i = (_l2 - _s) / _t3 * 200 - 100;
      }
      _this3.wrapperEl.clientPosition.xPercentage = s(e, -100, 100), _this3.wrapperEl.clientPosition.yPercentage = s(i, -100, 100);
    }, _this3.updateFlip = function () {
      var _this3$props4 = _this3.props,
        t = _this3$props4.flipVertically,
        e = _this3$props4.flipHorizontally;
      t && (_this3.tilt.tiltAngleX += 180, _this3.tilt.tiltAngleY *= -1), e && (_this3.tilt.tiltAngleY += 180);
    }, _this3.renderFrame = function () {
      _this3.resetWrapperElTransform(), _this3.renderPerspective(), _this3.tilt.render(_this3.wrapperEl.node), _this3.renderScale(), _this3.glare && _this3.glare.render(_this3.props);
    };
    return _this3;
  }
  _createClass(o, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.tilt = new l(), this.initGlare(), this.addEventListeners(), "undefined" == typeof CustomEvent) return;
      var t = new CustomEvent("autoreset");
      this.mainLoop(t);
      var e = new CustomEvent("initial");
      this.emitOnMove(e);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      null !== this.wrapperEl.updateAnimationId && cancelAnimationFrame(this.wrapperEl.updateAnimationId), this.removeEventListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var t = new CustomEvent("propChange");
      this.mainLoop(t), this.emitOnMove(t);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$props = this.props,
        t = _this$props.trackOnWindow,
        e = _this$props.gyroscope;
      window.addEventListener("resize", this.setSize), t && (window.addEventListener("mouseenter", this.onEnter), window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseout", this.onLeave), window.addEventListener("touchstart", this.onEnter), window.addEventListener("touchmove", this.onMove), window.addEventListener("touchend", this.onLeave)), e && this.addDeviceOrientationEventListener();
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this$props2 = this.props,
        t = _this$props2.trackOnWindow,
        e = _this$props2.gyroscope;
      window.removeEventListener("resize", this.setSize), t && (window.removeEventListener("mouseenter", this.onEnter), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseout", this.onLeave), window.removeEventListener("touchstart", this.onEnter), window.removeEventListener("touchmove", this.onMove), window.removeEventListener("touchend", this.onLeave)), e && window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.onMove);
    }
  }, {
    key: "setWrapperElSize",
    value: function setWrapperElSize() {
      var t = this.wrapperEl.node.getBoundingClientRect();
      this.wrapperEl.size.width = this.wrapperEl.node.offsetWidth, this.wrapperEl.size.height = this.wrapperEl.node.offsetHeight, this.wrapperEl.size.left = t.left + window.scrollX, this.wrapperEl.size.top = t.top + window.scrollY;
    }
  }, {
    key: "initGlare",
    value: function initGlare() {
      var _this$props3 = this.props,
        t = _this$props3.glareEnable,
        e = _this$props3.glareBorderRadius;
      t && (this.glare = new r(this.wrapperEl.size, e), this.wrapperEl.node.appendChild(this.glare.glareWrapperEl));
    }
  }, {
    key: "emitOnMove",
    value: function emitOnMove(t) {
      var e = this.props.onMove;
      if (!e) return;
      var i = 0,
        n = 0;
      this.glare && (i = this.glare.glareAngle, n = this.glare.glareOpacity), e({
        tiltAngleX: this.tilt.tiltAngleX,
        tiltAngleY: this.tilt.tiltAngleY,
        tiltAngleXPercentage: this.tilt.tiltAngleXPercentage,
        tiltAngleYPercentage: this.tilt.tiltAngleYPercentage,
        glareAngle: i,
        glareOpacity: n,
        eventType: t.type
      });
    }
  }, {
    key: "resetWrapperElTransform",
    value: function resetWrapperElTransform() {
      this.wrapperEl.node.style.transform = "";
    }
  }, {
    key: "renderPerspective",
    value: function renderPerspective() {
      var t = this.props.perspective;
      this.wrapperEl.node.style.transform += "perspective(".concat(t, "px) ");
    }
  }, {
    key: "renderScale",
    value: function renderScale() {
      var t = this.wrapperEl.scale;
      this.wrapperEl.node.style.transform += "scale3d(".concat(t, ",").concat(t, ",").concat(t, ")");
    }
  }, {
    key: "setTransitions",
    value: function setTransitions() {
      var _this$props4 = this.props,
        t = _this$props4.transitionSpeed,
        e = _this$props4.transitionEasing;
      n(this.wrapperEl.node, "all", t, e), this.glare && n(this.glare.glareEl, "opacity", t, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props5 = this.props,
        e = _this$props5.children,
        i = _this$props5.className,
        n = _this$props5.style;
      return t.createElement("div", {
        ref: function ref(t) {
          return _this4.wrapperEl.node = t;
        },
        onMouseEnter: this.onEnter,
        onMouseMove: this.onMove,
        onMouseLeave: this.onLeave,
        onTouchStart: this.onEnter,
        onTouchMove: this.onMove,
        onTouchEnd: this.onLeave,
        className: i,
        style: n
      }, e);
    }
  }]);
  return o;
}(e);
o.defaultProps = a;
export { o as default };